<template>
  <div class="search-modal">
    <el-popover
      ref="popover"
      popper-class="el-popper-search"
      placement="bottom"
      trigger="focus"
      width="200px"
      v-model="dialogAdd"
    >
      <el-form :model="data" ref="data" label-width="100px">
        <el-row>
          <el-col :span="24">
            <!-- 入库数量 -->
            <el-form-item :label="this.$t('purchaseReturn.form.goodList.inboundQuantity')">
              <el-input v-model="data.inboundQuantity" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- 可退货数量 -->
            <el-form-item :label="this.$t('purchaseReturn.form.goodList.quantity')">
              <el-input v-model="data.quantity" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <!-- 单价 -->
            <el-form-item :label="this.$t('purchaseReturn.form.goodList.businessContractPrice')">
              <el-input v-model="data.businessContractPrice" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <input-number
        class="el-input-table"
        slot="reference"
        v-model="value"
        :max="data.quantity"
        :precision="3"
        :placeholder="placeholder"
        @input="(val) => changeData(val)"
        :disabled="disabled || false"
        @focus="(val) => changeFocusData(val)"
      ></input-number>
    </el-popover>
  </div>
</template>
<script>
  import inputNumber from '@/components/form-item/input-number';
  export default {
    name: 'quantityOfExchange',
    props: {
      placeholder: {
        type: String,
        default: '',
      },
      data: {
        type: Object,
        default: () => {},
      },
      defaultValue: {
        type: [Number, String],
        default: '',
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
    },

    components: {
      inputNumber,
    },
    data() {
      return {
        dialogAdd: false,
        value: this.defaultValue && this.defaultValue != 'undefined' ? this.defaultValue : '',
        icon: 'el-icon-arrow-down',
      };
    },
    watch: {
      defaultValue(val) {
        this.value = val;
      },
    },
    mounted() {},
    methods: {
      //修改值
      changeData(val) {
        this.$emit('setSearchModal', val);
      },
      changeFocusData(val) {
        this.$emit('changeFocusData', val);
      },
    },
  };
</script>
<style lang="scss" scoped>
  $maintheme: #6299fe;

  .search-modal-footer {
    margin-top: 15px;
    text-align: center;
  }
  .el-button {
    border-radius: 2px;
  }
  .el-button--primary {
    background-color: $maintheme;
    border-color: $maintheme;
  }
</style>
